import React from 'react';
import axios from 'axios';
import {LOAD_DETAILS} from "../../../../api/Api";
import {Link, Redirect, Route, Switch, useLocation, useParams} from 'react-router-dom'
import GoogleMapsComponent from "../../../../components/Ui/GoogleMapsComponent";
import {makeStyles} from '@material-ui/core/styles';
import moment from 'moment'
import {ExpansionPanel as Accordion} from '@material-ui/core';
import {ExpansionPanelSummary as AccordionSummary} from '@material-ui/core';
import {ExpansionPanelDetails as AccordionDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {addHttpPrefix, convertToLocalState, getFileUrl} from "../../../../utils/helpers";
import {societes} from "../../../../utils/constants";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles((theme) => ({
    divider: {
        backgroundColor: theme.palette.primary.main,
        height: 5
    },
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
    details: {
        background: '#f1f1f1!important'
    },
    accordionRoot: {
        '&.MuiExpansionPanel-root:before': {
            display: 'none',
            '& *':{
                boxShadow: 'none!important'
            }
        },
        '&.MuiExpansionPanel-root': {
            boxShadow: 'none!important',
            background: 'none!important'
        },
        '& .MuiExpansionPanelDetails-root > div': {
            background: 'white',
            padding: theme.spacing(4,4),
            margin: theme.spacing(0,1),
            borderRadius: 8,
            border: 'solid gray 1px'
        }
    },

}));

function getSteps() {
    return ['Fiche enregistré', 'Analyse de votre demande', 'Prise en compte de votre demande', 'Realisation terminé'];
}

function getStepContent(step) {
    switch (step) {
        case 0:
            return `Enregistrement de la fiche. Début du procéssus`;
        case 1:
            return 'Nos agents analyse les informations envoyer lors de votre demande et se prépare à y répondre en cas de suite favorable.';
        case 2:
            return `Votre demande a été prise en compte. Nos équipe devront vous contacterons pour l'intervention.`;
        case 3:
            return `La demande a été executé avec succès. Les éléments on été déplacé`;
        default:
            return 'Unknown step';
    }
}

export default function FicheDetailsPage(props) {

    const params = useParams();
    const classes = useStyles();

    const [ficheDetails, setFicheDetails] = React.useState();
    const [isLoadingDetails, setIsLoadingDetails] = React.useState();
    const [ficheNotFound, setFicheNotFound] = React.useState(false);

    const location = useLocation();
    console.log(location)

    async function loadDetails() {

        try {

            setIsLoadingDetails(true);

            const response = await axios.get(
                `${LOAD_DETAILS}/${params.id}`,
                {}
            );

            setFicheDetails(response.data);

        } catch (e) {

            if (e.response && e.response.status === 404)
                setFicheNotFound(true)

        } finally {
            setIsLoadingDetails(false);
        }

    }


    const localState = React.useMemo(
        () => {
            if (ficheDetails) {
                let localState = convertToLocalState(ficheDetails.state);
                return localState;
            }
        }, [ficheDetails]
    )


    const steps = React.useMemo(
        () => {

            if (!ficheDetails)
                return [];

            const currentLocalState = localState;

            const prevStepArray = getSteps();
            const stepArray = [];

            //We choose 1, because the first step (fiche enregistrer) is not showed her, what is showed is rather fiche_validated
            for (let stepItem = 0; stepItem <= currentLocalState; stepItem++) {

                if (stepItem === 0) {
                    stepArray.push(`${prevStepArray[stepItem]} (${moment(ficheDetails.created_at).format('DD/MM/Y hh:mm')})`);
                    continue;
                }

                if (stepItem === 4)
                    continue;

                const date = '';

                console.log('step item', stepItem, date);

                if (date)
                    stepArray.push(`${prevStepArray[stepItem]} (${moment(date).format('DD/MM/Y hh:mm')})`);

                else
                    stepArray.push(`${prevStepArray[stepItem]}`);

            }

            return stepArray;
        }, [ficheDetails]
    );
    const activeStep = React.useMemo(
        () => {
            if (ficheDetails) {
                let localState = convertToLocalState(ficheDetails.state);
                console.log('local state ', localState);
                return localState - 1;
            }
        }, [ficheDetails]
    )


    React.useEffect(() => {

        loadDetails();

    }, [])

    return (
        <div className={`${classes.root}bg-white`}>

            {
                isLoadingDetails && (
                    <div>
                        En cours de chargement
                    </div>
                )
            }


            {
                ficheNotFound && (
                    <Redirect to={'/'}/>
                )
            }

            {
                ficheDetails && (

                    <div className={'row'}>

                        <div>

                            <div className={'font-weight-bolder h2 px-5 py-5'}>
                                <div className={'small font-weight-light text-dark'}>Numéro de demande</div>

                                <div className={'font-weight-bold text-success'}>
                                    { ficheDetails.code }
                                </div>
                            </div>

                            <Accordion className={classes.accordionRoot} defaultExpanded={true}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >

                                    <div className={'h3 font-weight-bold w-100'}>
                                        <div className="mb-5">Contacts</div>
                                        <Divider />
                                    </div>


                                </AccordionSummary>
                                <AccordionDetails>

                                    <div className={'row'}>

                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>
                                                Type du client
                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {ficheDetails.type_client_data?.libelle}
                                        </div>

                                        {
                                            ficheDetails.type_client_id === 1 && (
                                                <>

                                                    <div className={'col-6'}>

                                                        <div className={'underlined font-weight-light my-3'}>
                                                            Nom & Prénoms
                                                        </div>

                                                    </div>

                                                    <div className={' col-6 font-weight-bold font-weight-bold'}>
                                                        {ficheDetails.nom} {ficheDetails.prenoms}
                                                    </div>

                                                </>
                                            )
                                        }


                                        {
                                            [2,3].includes(ficheDetails.type_client_id) && (
                                                <>

                                                    <div className={'col-6'}>

                                                        <div className={'underlined font-weight-light my-3'}>
                                                            Raison sociale
                                                        </div>

                                                    </div>

                                                    <div className={' col-6 font-weight-bold'}>
                                                        {ficheDetails.raison_sociale}
                                                    </div>

                                                </>
                                            )
                                        }

                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>
                                                Email
                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {ficheDetails.email}
                                        </div>


                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>
                                                Numéro de téléphone
                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {ficheDetails.mobile}
                                        </div>

                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>
                                                Second Numéro de téléphone
                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {ficheDetails.mobile_2}
                                        </div>

                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>
                                                Siège social de l'entreprise
                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {ficheDetails.siege_sociale}
                                        </div>

                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>
                                                Nom de l'entreprise
                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {ficheDetails.nom_enterprise}
                                        </div>


                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>
                                                Nom du sous traitant
                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {ficheDetails.nom_sous_traitant}
                                        </div>

                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>
                                                Nom du responsable chantier
                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {ficheDetails.nom_prenoms_responsable_chantier}
                                        </div>


                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>
                                                Contact du responsable chantier
                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {ficheDetails.contact_responsable_chantier}
                                        </div>

                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>
                                                Informations supplémentaires
                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {ficheDetails.informations_supplementaire}
                                        </div>

                                    </div>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion className={classes.accordionRoot} defaultExpanded={true}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >

                                    <div className={'h3 font-weight-bold w-100'}>
                                        <div className="mb-5">Description</div>
                                        <Divider />
                                    </div>

                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className={'row'}>

                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>

                                                Type de la demande

                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {societes[ficheDetails.type_travaux]}
                                        </div>


                                        <div className={'col-md-6'}>

                                            <div className={'underlined font-weight-light my-3'}>

                                                Objet de la demande

                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>

                                            {[...ficheDetails.nature_travaux_data.map(item => item.libelle), ficheDetails.autre_cie, ficheDetails.autre_sodeci]
                                                .filter(item=>!!item).map(
                                                    (item, index) => {
                                                        if (index === ficheDetails.nature_travaux_data.length)
                                                            return item;

                                                        return item + ', ';
                                                    }
                                                )}
                                        </div>



                                        <div className={'col-6'}>

                                            <div className={'underlined font-weight-light my-3'}>

                                                Description des travaux

                                            </div>

                                        </div>

                                        <div className={' col-6 font-weight-bold'}>
                                            {ficheDetails.description_travaux}
                                        </div>


                                        {(
                                            ficheDetails.type_travaux == 1 ||
                                            ficheDetails.type_travaux == 3) && (
                                            <>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Techniques des travaux

                                                    </div>

                                                </div>

                                                <div className={' col-6 font-weight-bold'}>

                                                {ficheDetails.technique_travaux_data.map(
                                                        item => {
                                                            return item.libelle
                                                        }
                                                    ).join(', ')}
                                                    
                                                                                                
                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Type de terrassement

                                                    </div>

                                                </div>

                                                <div className={' col-6 font-weight-bold'}>
                                                {ficheDetails.technique_terrassement_type.join(', ')}
                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>
                                                        Hauteur | Profondeur
                                                    </div>

                                                </div>

                                                <div className={'row col-6 font-weight-bold'}>

                                                    <table className="table table-bordered">

                                                        <thead>
                                                        <tr>
                                                            {
                                                                ficheDetails.hauteurs.remblai && (
                                                                    <td>Remblai</td>
                                                                )
                                                            }
                                                            {
                                                                ficheDetails.hauteurs.deblai && (
                                                                    <td>Déblai</td>
                                                                )
                                                            }
                                                            {
                                                                ficheDetails.hauteurs.demolition && (
                                                                    <td>Démolition, Construction</td>
                                                                )
                                                            }
                                                            {
                                                                ficheDetails.hauteurs.fouille && (
                                                                    <td>Fouille</td>
                                                                )
                                                            }
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            {
                                                                ficheDetails.hauteurs.remblai && (
                                                                    <td>{ficheDetails.hauteurs.remblai} m</td>
                                                                )
                                                            }

                                                            {
                                                                ficheDetails.hauteurs.deblai && (
                                                                    <td>{ ficheDetails.hauteurs.deblai } m</td>
                                                                )
                                                            }
                                                            {
                                                                ficheDetails.hauteurs.demolition && (
                                                                    <td>{ficheDetails.hauteurs.demolition} m</td>
                                                                )
                                                            }
                                                            {
                                                                ficheDetails.hauteurs.fouille && (
                                                                    <td>{ficheDetails.hauteurs.fouille} m</td>
                                                                )
                                                            }
                                                        </tr>
                                                        </tbody>

                                                    </table>

                                                </div>


                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Moyens utilisés

                                                    </div>

                                                </div>

                                                <div className={' col-6 font-weight-bold'}>
                                                    {[ficheDetails.moyens_utilises.map(item=>item.libelle), ficheDetails.moyen_utilise_travaux_autre].map(
                                                        (item, index) => {
                                                            if (index === ficheDetails.moyen_utilise_travaux.length)
                                                                return item;

                                                            return item + ', ';
                                                        }
                                                    )}
                                                </div>

                                            </>
                                        )
                                        }




                                        {
                                            [
                                                ficheDetails.plan_implentation_travaux,
                                            ].filter(item => !!item).map(
                                                anyy => {
                                                    return (
                                                        <>
                                                            <div className={'col-6'}>

                                                                <div className={'underlined font-weight-light my-3'}>

                                                                    Fichier de plan d'implantation

                                                                </div>

                                                            </div>

                                                            <div className={' col-6'}>

                                                                {
                                                                    ficheDetails.plan_implentation_travaux.map(
                                                                        item => {
                                                                            return (
                                                                                <a href={getFileUrl(item.value)} target='_blank'
                                                                                   className={'btn btn-icons btn-light-primary'}>
                                                                                    <i className={'la la-search'}/>
                                                                                </a>
                                                                            )
                                                                        }
                                                                    )
                                                                }

                                                                {
                                                                    ficheDetails.implantation_travaux_files_link && (
                                                                        <div>

                                                                            <a href={addHttpPrefix(ficheDetails.implantation_travaux_files_link)} target={'_blank'}>{addHttpPrefix(ficheDetails.implantation_travaux_files_link)}</a>

                                                                        </div>
                                                                    )
                                                                }


                                                            </div>

                                                        </>
                                                    )
                                                }
                                            )
                                        }


                                    </div>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion className={classes.accordionRoot} defaultExpanded={true}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >

                                    <div className={'h3 font-weight-bold w-100'}>
                                        <div className="mb-5">Localisation</div>
                                        <Divider />
                                    </div>

                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className={'w-100'}>

                                        <div className="row">

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Équipement CIE/SODECI le plus proche

                                                </div>

                                            </div>

                                            <div className={' col-6 font-weight-bold'}>
                                                {ficheDetails.adresse_equipement_cie_proche}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Zone des travaux

                                                </div>

                                            </div>

                                            <div className="col-6">

                                                {
                                                    ficheDetails.zone_travaux_file && (

                                                        <a
                                                            target={'_blank'}
                                                            href={getFileUrl(ficheDetails.zone_travaux_file)} className={'btn btn-icon btn-light-primary'}>
                                                            <i className={'la la-search'}/>
                                                        </a>

                                                    )
                                                }
                                                {
                                                    !ficheDetails.zone_travaux_file && (
                                                        <span>-</span>
                                                    )
                                                }


                                                {
                                                    ficheDetails.zone_travaux_file_link && (
                                                        <div>

                                                            <a href={addHttpPrefix(ficheDetails.zone_travaux_file_link)} target={'_blank'}>{addHttpPrefix(ficheDetails.zone_travaux_file_link)}</a>

                                                        </div>
                                                    )
                                                }

                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Villes

                                                </div>

                                            </div>

                                            <div className={' col-6 font-weight-bold'}>
                                                {ficheDetails.villes.map(
                                                    (item,index) => {

                                                        if(index == ficheDetails.villes.length - 1)
                                                            return item.libelle;

                                                        return item.libelle + ', '
                                                    }
                                                )}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Communes

                                                </div>

                                            </div>

                                            <div className={'col-6  font-weight-bold'}>
                                                {ficheDetails.communes.map(
                                                    (item,index) => {

                                                        if(index == ficheDetails.communes.length - 1)
                                                            return item.libelle;

                                                        return item.libelle + ', '
                                                    }
                                                )}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Quartiers

                                                </div>

                                            </div>

                                            <div className={' font-weight-bold col-6'}>
                                                {ficheDetails.quartiers.map(
                                                    (item,index) => {

                                                        if(index == ficheDetails.quartiers.length - 1)
                                                            return item.libelle;

                                                        return item.libelle + ', '
                                                    }
                                                )}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Rues

                                                </div>

                                            </div>

                                            <div className={' font-weight-bold col-6'}>
                                                {ficheDetails.rue}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Description localisation

                                                </div>

                                            </div>

                                            <div className=" font-weight-bold col-6">
                                                {ficheDetails.description_localisation}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Fichiers numériques de plan d'ouvrage

                                                </div>

                                            </div>

                                            <div className=" col-6">

                                                {
                                                    ficheDetails.fichiers_numerique_ouvrage.map(
                                                        item => {
                                                            return (
                                                                <a href={getFileUrl(item.value)} target='_blank'
                                                                   className="btn btn-icon btn-light-primary">
                                                                    <span className="la la-search"></span>
                                                                </a>
                                                            );
                                                        }
                                                    )
                                                }

                                                {
                                                    ficheDetails.ouvrages_numeriques_files_link && (
                                                        <div>

                                                            <a href={addHttpPrefix(ficheDetails.ouvrages_numeriques_files_link)} target={'_blank'}>{addHttpPrefix(ficheDetails.ouvrages_numeriques_files_link)}</a>

                                                        </div>
                                                    )
                                                }

                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Description localisation

                                                </div>

                                            </div>


                                            <div className=" col-6">
                                                <GoogleMapsComponent
                                                    markers={ficheDetails.lat_lng}
                                                />
                                            </div>

                                        </div>

                                    </div>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion className={classes.accordionRoot} defaultExpanded={true}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >

                                    <div className={'h3 font-weight-bold w-100'}>
                                        <div className="mb-5">Période</div>
                                        <Divider />
                                    </div>

                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className={'w-100'}>
                                        <div className="row">

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Date de début des travaux

                                                </div>

                                            </div>

                                            <div className={' font-weight-bold col-6'}>
                                                {moment(ficheDetails.date_debut_travaux).format('DD/MM/YYYY')}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Date de fin des travaux

                                                </div>

                                            </div>

                                            <div className={' font-weight-bold col-6'}>
                                                {moment(ficheDetails.date_fin_travaux).format('DD/MM/YYYY')}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Informations supplémentaires

                                                </div>

                                            </div>

                                            <div className={'col-6 font-weight-bold'}>
                                                {ficheDetails.informations_supplementaire_periode}
                                            </div>

                                            <div className="col-6">


                                                <div className={'underlined font-weight-light my-3'}>

                                                    Fichiers de planning des travaux

                                                </div>

                                            </div>

                                            <div className={' col-6'}>

                                                {
                                                    ficheDetails.planning_travaux.map(
                                                        item => {
                                                            return (
                                                                <a href={getFileUrl(item.value)} target='_blank'
                                                                   className="btn btn-icon btn-light-primary">
                                                                    <span className="la la-search"></span>
                                                                </a>
                                                            );
                                                        }
                                                    )
                                                }


                                                {
                                                    ficheDetails.planning_travaux_file_link && (
                                                        <div>

                                                            <a href={addHttpPrefix(ficheDetails.planning_travaux_file_link)} target={'_blank'}>{addHttpPrefix(ficheDetails.planning_travaux_file_link)}</a>

                                                        </div>
                                                    )
                                                }

                                            </div>

                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>


                            {/*<div className={'px-md-7 px-4 py-5 mx-md-12 mx-4'}>*/}

                            {/*    <div className={'row'}>*/}

                            {/*        <div className="col-12 mt-8">*/}
                            {/*            <div className={'h2 text-primary font-weight-bold'}>*/}
                            {/*                Description*/}

                            {/*                <Divider className={classes.divider} />*/}

                            {/*            </div>*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Type de la demande*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={'col-6 '}>*/}
                            {/*            {societes[ficheDetails.type_travaux]}*/}
                            {/*        </div>*/}


                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Nature des travaux*/}

                            {/*            </div>*/}

                            {/*        </div>*/}


                            {/*        <div className={'col-6 '}>*/}

                            {/*            {[...ficheDetails.nature_travaux_data.map(item => item.libelle), ficheDetails.autre_cie, ficheDetails.autre_sodeci]*/}
                            {/*                .filter(item => !!item).map(*/}
                            {/*                    (item, index) => {*/}
                            {/*                        if (index === ficheDetails.nature_travaux_data.length)*/}
                            {/*                            return item;*/}

                            {/*                        return item + ', ';*/}
                            {/*                    }*/}
                            {/*                )}*/}
                            {/*        </div>*/}


                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Description des travaux*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.description_travaux}*/}
                            {/*        </div>*/}


                            {/*        {(*/}
                            {/*            ficheDetails.type_travaux == 1 ||*/}
                            {/*            ficheDetails.type_travaux == 3) && (*/}
                            {/*            <>*/}

                            {/*                <div className={'col-6'}>*/}

                            {/*                    <div className={' font-weight-light my-3'}>*/}

                            {/*                        Techniques des travaux*/}

                            {/*                    </div>*/}

                            {/*                </div>*/}

                            {/*                <div className={' col-6'}>*/}
                            {/*                    {ficheDetails.technique_travaux_data ?*/}
                            {/*                        ficheDetails.technique_travaux_data.libelle : '-'*/}
                            {/*                    }*/}
                            {/*                </div>*/}

                            {/*                <div className={'col-6'}>*/}

                            {/*                    <div className={' font-weight-light my-3 small'}>*/}

                            {/*                        Type de terrassement*/}

                            {/*                    </div>*/}

                            {/*                </div>*/}

                            {/*                <div className={' col-6'}>*/}
                            {/*                    {ficheDetails.technique_terrassement_type}*/}
                            {/*                </div>*/}


                            {/*                <div className={'col-6'}>*/}

                            {/*                    <div className={' font-weight-light my-3'}>*/}
                            {/*                        Hauteur | Profondeur*/}
                            {/*                    </div>*/}

                            {/*                </div>*/}

                            {/*                <div className={' col-6'}>*/}
                            {/*                    {ficheDetails.hauteur}*/}
                            {/*                </div>*/}


                            {/*                <div className={'col'}>*/}

                            {/*                    <div className={' font-weight-light my-3'}>*/}

                            {/*                        Moyens utilisés*/}

                            {/*                    </div>*/}

                            {/*                </div>*/}

                            {/*                <div className={' col-6'}>*/}
                            {/*                    {[ficheDetails.moyens_utilises.map(item => item.libelle), ficheDetails.moyen_utilise_travaux_autre]*/}
                            {/*                        .filter(item => !!item).map(*/}
                            {/*                            (item, index) => {*/}
                            {/*                                if (index === ficheDetails.moyen_utilise_travaux.length)*/}
                            {/*                                    return item;*/}

                            {/*                                return item + ', ';*/}
                            {/*                            }*/}
                            {/*                        )}*/}
                            {/*                </div>*/}


                            {/*            </>*/}
                            {/*        )*/}
                            {/*        }*/}


                            {/*        {*/}
                            {/*            [*/}
                            {/*                ficheDetails.plan_implentation_travaux,*/}
                            {/*                ficheDetails.plan_implentation_travaux_fichier_2,*/}
                            {/*                ficheDetails.plan_implentation_travaux_fichier_3,*/}
                            {/*            ].filter(item => !!item).map(*/}
                            {/*                item => {*/}
                            {/*                    return (*/}
                            {/*                        <>*/}
                            {/*                            <div className={'col-6'}>*/}

                            {/*                                <div className={' font-weight-light my-3 small'}>*/}

                            {/*                                    Fichier de plan d'implentation*/}

                            {/*                                </div>*/}

                            {/*                            </div>*/}

                            {/*                            <div className={' col-6'}>*/}


                            {/*                                {*/}
                            {/*                                    ficheDetails.fichiers_numerique_ouvrage.map(*/}
                            {/*                                        item => {*/}
                            {/*                                            return (*/}
                            {/*                                                <a href={getFileUrl(item.value)}*/}
                            {/*                                                   target='_blank'*/}
                            {/*                                                   rel={'noreferrer noopener'}*/}
                            {/*                                                   className="btn btn-icon btn-light-primary">*/}
                            {/*                                                    <span className="la la-search"></span>*/}
                            {/*                                                </a>*/}
                            {/*                                            );*/}
                            {/*                                        }*/}
                            {/*                                    )*/}
                            {/*                                }*/}


                            {/*                            </div>*/}
                            {/*                        </>*/}
                            {/*                    )*/}
                            {/*                }*/}
                            {/*            )*/}
                            {/*        }*/}


                            {/*    </div>*/}

                            {/*    <div className="row">*/}

                            {/*        <div className="col-12 mt-8">*/}
                            {/*            <div className={'h2 text-primary font-weight-bold'}>*/}
                            {/*                Localisation*/}

                            {/*                <Divider className={classes.divider} />*/}
                            {/*            </div>*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3 small'}>*/}

                            {/*                Equipement CIE/SODECI le plus proche*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}
                            {/*            {ficheDetails.adresse_equipement_cie_proche}*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6 mt-8'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Zone des travaux*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className="col-6">*/}

                            {/*            {*/}
                            {/*                ficheDetails.zone_travaux_file && (*/}

                            {/*                    <a*/}
                            {/*                        target={'_blank'}*/}
                            {/*                        href={getFileUrl(ficheDetails.zone_travaux_file)}*/}
                            {/*                       className={'btn btn-icon btn-light-primary'}>*/}
                            {/*                        <i className={'la la-search'}/>*/}
                            {/*                    </a>*/}

                            {/*                )*/}
                            {/*            }*/}
                            {/*            {*/}
                            {/*                !ficheDetails.zone_travaux_file && (*/}
                            {/*                    <span>-</span>*/}
                            {/*                )*/}
                            {/*            }*/}

                            {/*        </div>*/}

                            {/*        <div className={'col-6 my-3'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Villes*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.villes.map(*/}
                            {/*                (item, index) => {*/}

                            {/*                    if (index == ficheDetails.villes.length - 1)*/}
                            {/*                        return item.libelle;*/}

                            {/*                    return item.libelle + ', '*/}
                            {/*                }*/}
                            {/*            )}*/}
                            {/*        </div>*/}


                            {/*        <div className={'col-6 my-3'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Communes*/}

                            {/*            </div>*/}


                            {/*        </div>*/}


                            {/*        <div className={'col-6 '}>*/}
                            {/*            {ficheDetails.communes.map(*/}
                            {/*                (item, index) => {*/}

                            {/*                    if (index == ficheDetails.communes.length - 1)*/}
                            {/*                        return item.libelle;*/}

                            {/*                    return item.libelle + ', '*/}
                            {/*                }*/}
                            {/*            )}*/}
                            {/*        </div>*/}


                            {/*        <div className={'col-6 my-3'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Quartiers*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.quartiers.map(*/}
                            {/*                (item, index) => {*/}

                            {/*                    if (index == ficheDetails.quartiers.length - 1)*/}
                            {/*                        return item.libelle;*/}

                            {/*                    return item.libelle + ', '*/}
                            {/*                }*/}
                            {/*            )}*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6 my-3'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Rues*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.rues.map(*/}
                            {/*                (item, index) => {*/}

                            {/*                    if (index == ficheDetails.rues.length - 1)*/}
                            {/*                        return item.libelle;*/}

                            {/*                    return item.libelle + ', '*/}
                            {/*                }*/}
                            {/*            )}*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Description localisation*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className=" col-6">*/}
                            {/*            {ficheDetails.description_localisation}*/}
                            {/*        </div>*/}


                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Fichiers numérique de plan d'ouvrage*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className=" col-6">*/}

                            {/*            {*/}
                            {/*                ficheDetails.fichiers_numerique_ouvrage.map(*/}
                            {/*                    item => {*/}
                            {/*                        return (*/}
                            {/*                            <a href={getFileUrl(item.value)} target='_blank'*/}
                            {/*                               className="btn btn-icon btn-light-primary">*/}
                            {/*                                <span className="la la-search"></span>*/}
                            {/*                            </a>*/}
                            {/*                        );*/}
                            {/*                    }*/}
                            {/*                )*/}
                            {/*            }*/}

                            {/*        </div>*/}


                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Description localisation*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className=" col-6">*/}


                            {/*            {*/}
                            {/*                ficheDetails.geo_lat && ficheDetails.geo_lng && (*/}

                            {/*                    <GoogleMapsComponent*/}
                            {/*                        location={{*/}
                            {/*                            lat: parseFloat(ficheDetails.geo_lat),*/}
                            {/*                            lng: parseFloat(ficheDetails.geo_lng)*/}
                            {/*                        }}*/}
                            {/*                    />*/}

                            {/*                )*/}
                            {/*            }*/}

                            {/*            {*/}
                            {/*                !ficheDetails.geo_lat && !ficheDetails.geo_lng && (*/}

                            {/*                    <div>*/}
                            {/*                        Aucune position n'a été choisie*/}
                            {/*                    </div>*/}

                            {/*                )*/}
                            {/*            }*/}
                            {/*        </div>*/}


                            {/*    </div>*/}

                            {/*    <div className="row">*/}


                            {/*        <div className="col-12 mt-8">*/}
                            {/*            <div className={'h2 text-primary font-weight-bold'}>*/}
                            {/*                Période*/}

                            {/*                <Divider className={classes.divider} />*/}

                            {/*            </div>*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Date de début des travaux*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {moment(ficheDetails.date_debut_travaux).format('DD/MM/YYYY')}*/}
                            {/*        </div>*/}


                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Date de fin des travaux*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {moment(ficheDetails.date_fin_travaux).format('DD/MM/YYYY')}*/}
                            {/*        </div>*/}


                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}

                            {/*                Informations supplémentaires*/}

                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.informations_supplementaire_periode}*/}
                            {/*        </div>*/}


                            {/*        <div className="col-6">*/}


                            {/*            <div className={' font-weight-light my-3 small'}>*/}

                            {/*                Fichiers de planning des travaux*/}

                            {/*            </div>*/}

                            {/*        </div>*/}
                            {/*        <div className={' col-6'}>*/}

                            {/*            {*/}
                            {/*                ficheDetails.planning_travaux.map(*/}
                            {/*                    item => {*/}
                            {/*                        return (*/}
                            {/*                            <a href={getFileUrl(item.value)} target='_blank'*/}
                            {/*                               className="btn btn-icon btn-light-primary">*/}
                            {/*                                <span className="la la-search"></span>*/}
                            {/*                            </a>*/}
                            {/*                        );*/}
                            {/*                    }*/}
                            {/*                )*/}
                            {/*            }*/}

                            {/*        </div>*/}

                            {/*    </div>*/}

                            {/*    <div className={'row'}>*/}


                            {/*        <div className="col-12 mt-8">*/}
                            {/*            <div className={'h2 text-primary font-weight-bold'}>*/}
                            {/*                Contact*/}

                            {/*                <Divider className={classes.divider} />*/}

                            {/*            </div>*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3'}>*/}
                            {/*                Type du client*/}
                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.type_client_data?.libelle}*/}
                            {/*        </div>*/}

                            {/*        {*/}
                            {/*            ficheDetails.type_client_id === 1 && (*/}
                            {/*                <>*/}

                            {/*                    <div className={'col-6'}>*/}

                            {/*                        <div className={' font-weight-light my-3'}>*/}
                            {/*                            Nom & Prenoms*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}
                            {/*                    */}
                            {/*                    <div className={' col-6'}>*/}
                            {/*                        {ficheDetails.nom} {ficheDetails.prenoms}*/}
                            {/*                    </div>*/}
                            {/*                </>*/}
                            {/*            )*/}
                            {/*        }*/}


                            {/*        {*/}
                            {/*            [2, 3].includes(ficheDetails.type_client_id) && (*/}
                            {/*                <>*/}
                            {/*                    <div className={'col-6'}>*/}

                            {/*                        <div className={' font-weight-light my-3'}>*/}
                            {/*                            Raison sociale*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={' col-6'}>*/}
                            {/*                        {ficheDetails.raison_sociale}*/}
                            {/*                    </div>*/}
                            {/*                </>*/}
                            {/*            )*/}
                            {/*        }*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3  font-weight-light my-3'}>*/}
                            {/*                Email*/}
                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.email}*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3 small'}>*/}
                            {/*                Numéro de téléphone*/}
                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.mobile}*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3 small'}>*/}
                            {/*                Second Numéro de téléphone*/}
                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.mobile_2}*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3 small'}>*/}
                            {/*                Siège de sociale de l'entreprise*/}
                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.siege_sociale}*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3 small'}>*/}
                            {/*                Nom de l'entreprise*/}
                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.nom_enterprise}*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3 small'}>*/}
                            {/*                Nom du sous traitant*/}
                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.nom_sous_traitant}*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3 small'}>*/}
                            {/*                Nom responsable chantier*/}
                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.nom_prenoms_responsable_chantier}*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3 small'}>*/}
                            {/*                Contacts responsable chantier*/}
                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.contact_responsable_chantier}*/}
                            {/*        </div>*/}

                            {/*        <div className={'col-6'}>*/}

                            {/*            <div className={' font-weight-light my-3 small'}>*/}
                            {/*                Informations supplémentaires*/}
                            {/*            </div>*/}

                            {/*        </div>*/}

                            {/*        <div className={' col-6'}>*/}
                            {/*            {ficheDetails.informations_supplementaire}*/}
                            {/*        </div>*/}

                            {/*    </div>*/}

                            {/*</div>*/}


                        </div>

                    </div>

                )
            }

        </div>
    );

}